import React from "react";
import { Input, Form } from "antd";

const FormFields = () => {
  return (
    <>
      {/* --- CHAMP CODE AJOUTÉ --- */}
      <Form.Item
        name="sampleCode"
        label="Code de l'échantillon"
        rules={[
          {
            required: true, // Mettez false si optionnel
            message: "Veuillez entrer le code de l'échantillon",
          },
        ]}
      >
        <Input placeholder="Code (ex: DHMINI...)" />
      </Form.Item>
      {/* ------------------------- */}

      <Form.Item
        name="name"
        label="Nom d'échantillon"
        rules={[
          {
            required: true,
            message: "S'il vous plaît entrer le nom d'échantillon",
          },
        ]}
      >
        <Input placeholder="Nom d'échantillon" />
      </Form.Item>
    </>
  );
};

export default FormFields;